import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { createContext } from "react";
import { useResizeDetector } from "react-resize-detector";
const RootWidthContext = /*#__PURE__*/ createContext(void 0);
const DESKTOP_WIDTH_DEFAULT = 1024;
const RootWidthContextProvider = (t0)=>{
    const $ = c(17);
    const { children, page } = t0;
    const { width, ref } = useResizeDetector();
    if ("sideMenu" === page) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ jsx(RootWidthContext.Provider, {
                value: DESKTOP_WIDTH_DEFAULT,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if ("header" === page) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                width: "100%"
            };
            $[2] = t1;
        } else t1 = $[2];
        let t2;
        if ($[3] !== children) {
            t2 = /*#__PURE__*/ jsx("div", {
                style: t1,
                children: /*#__PURE__*/ jsx(RootWidthContext.Provider, {
                    value: DESKTOP_WIDTH_DEFAULT,
                    children: children
                })
            });
            $[3] = children;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            width: "100%"
        };
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== width) {
        t2 = {
            containerType: "inline-size",
            width
        };
        $[6] = width;
        $[7] = t2;
    } else t2 = $[7];
    const t3 = t2;
    let t4;
    if ($[8] !== children || $[9] !== width) {
        t4 = /*#__PURE__*/ jsx(RootWidthContext.Provider, {
            value: width,
            children: children
        });
        $[8] = children;
        $[9] = width;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ jsx("div", {
            style: t3,
            children: t4
        });
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== ref || $[15] !== t5) {
        t6 = /*#__PURE__*/ jsx("div", {
            ref: ref,
            id: "sizeme",
            style: t1,
            children: t5
        });
        $[14] = ref;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
export { RootWidthContext, RootWidthContextProvider };
